import { Platform } from 'react-native';

if (Platform.OS === 'web') {
  module.exports = {
    unlink: () => {}
  }
}



// WEBPACK FOOTER //
// ./src/wrappers/react-native-push-notification.js